module.exports = __webpack_public_path__ + "static/media/sign_up_bg.a8cb0817.png";